// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> fairforest-creekside
// Generated: 2026-10-29T18:34:10.372Z
// Counts: 0 design, 26 content, 49 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Each townhome comes with smart-home technology, in-unit laundry, granite countertops and a private fenced backyard, and lawn maintenance is included. Around the community you'll find a dog park, a pickleball court, grills and a fire pit. <a href=\"/amenities\">See all amenities</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to live, inside and out</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Fairforest Creekside's shared spaces are built for easy outdoor time: a pickleball court, a fenced dog park with agility equipment, and a covered pavilion with grills and a fire pit. Take a closer look in our <a href=\"/gallery\">photo gallery</a>.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a filter change twice a year, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Free rent on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Three-bedroom townhomes in Greenville's Pleasantburg area</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Fairforest Creekside, a week might mean pickleball after work, burgers at the grill pavilion, an evening around the fire pit, and a morning run at the <a href=\"/amenities\">dog park</a>. The yard work is covered, so the weekend stays yours.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>I-385 and I-85 are close by, so getting to work or Haywood Mall is easy, and on weekends you can walk the trails at Conestee Nature Preserve or head into downtown for Falls Park on the Reedy and the Swamp Rabbit Trail. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pleasantburg living, minutes from downtown</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>With fenced backyards, an on-site dog park with agility equipment, and Conestee Nature Preserve nearby for longer walks, Fairforest Creekside makes life with dogs and cats easy. Get the details in our <a href=\"/pet-policy\">pet policy</a>.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>See the Churchill or Litchfield in person on your own schedule with a <a href=\"/schedule-a-tour\">self-guided tour</a>, or stop by and let our leasing team walk you through a townhome.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Get a feel for Fairforest Creekside's three-bedroom townhomes from anywhere: pick a tour from the list and explore at your own pace, then <a href=\"/schedule-a-tour\">book a self-guided tour</a> when you're ready to see one in person.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenities-hero.photo": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Private Backyard"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8e54-75b3-a94a-b421cebfe85e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a townhouse building with covered patios and white fencing."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8b3f-7258-9aaa-3e48a7a0df0c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of townhomes with manicured lawns and sidewalks."
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-7b12-7267-80d4-4b838c5f9fe6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with wood floors and view into the kitchen area with stainless steel appliances."
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-9297-74ac-a318-98ddaed38166.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced community court area next to the Fairforest Creekside dog park"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Washer/Dryer"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-6c96-74c3-8f03-961bd960dcc1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Washer and dryer in a laundry closet with shelving."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Granite Countertops"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-9e68-724a-82e8-4d87dba61c20.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances and granite countertops"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-94db-749f-9d8b-85f78f2b7185.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fairforest Creekside pickleball court beside the covered pavilion"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-9297-74ac-a318-98ddaed38166.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fairforest Creekside pickleball court beside the green-roofed community pavilion"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-7b12-7267-80d4-4b838c5f9fe6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome living room with wood-look floors opening to a kitchen with stainless steel appliances"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-94db-749f-9d8b-85f78f2b7185.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Pickleball court with the Fairforest Creekside name painted on the surface"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pickleball"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-960d-7010-bf90-2d42d71eb012.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "On-site dog park lawn with a red agility barrel"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-90ad-74a6-8daa-7efba004cfa0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered picnic pavilion with a green roof and grills next to the courts"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Picnic Pavilion"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8b3f-7258-9aaa-3e48a7a0df0c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of townhomes with manicured lawns and sidewalks."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Lawns"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8e54-75b3-a94a-b421cebfe85e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fairforest Creekside townhomes with covered back patios and white-fenced private yards"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fenced Yards"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-b225-722e-9b1e-5e1bc8979a41.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clean attached single-car garage with a white overhead door and automatic opener"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Attached Garage"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-8233-7513-93a1-97bf6d00c6d2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White Fairforest Creekside townhome with blue front door and brick accents"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-aa36-7249-86a6-a64fd16036e5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Litchfield bedroom with walk-in closet, large windows and wood-look flooring"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-ac5c-720e-8433-97917b33ce15.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a new townhome community with white buildings and dark roofs, surrounded by trees in autumn."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-d7bb-76c8-82a0-c9045fba2b33.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with granite island, stainless steel appliances, and open-concept living area."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-94db-749f-9d8b-85f78f2b7185.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fairforest Creekside pickleball court with the community name on the court"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-7b12-7267-80d4-4b838c5f9fe6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with wood floors and view into the kitchen area with stainless steel appliances."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-90ad-74a6-8daa-7efba004cfa0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered picnic pavilion with green roof beside the pickleball court"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-c28f-72f9-80c7-7f566d94a805.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of modern townhomes with white siding and teal doors."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-960d-7010-bf90-2d42d71eb012.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced community dog park with agility equipment on a green lawn"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8082-71b3-be1e-2a29ba4b7131.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen island with granite countertops and stainless steel appliances."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Your own backyard"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Unwind in your fenced backyard or on the covered patio under the ceiling fan, and leave the mowing to our lawn maintenance crew."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Grill and gather"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Meet neighbors at the covered picnic pavilion with grills and a fire pit, right beside the pickleball courts and the dog park's agility course."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three bedrooms, plus flex space in select layouts, you can turn a spare room into a quiet home office and run it with smart-home tech."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3567-7767-a175-627ea7defc47.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Trails and wetlands at Conestee Nature Preserve in Greenville"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Conestee Nature Preserve"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-9ab3-7525-b3f4-d6ef54904417.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of townhomes with private patios and green space."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Community green space"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-6c8f-776d-a2f6-78b2f10fcccc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a row of modern white townhomes with blue doors."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome Exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-90ad-74a6-8daa-7efba004cfa0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered picnic pavilion with grills next to the community courts"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Picnic Pavilion"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-eb0a-74bc-84f0-6748d18e0fd8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with island and stainless steel appliances."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-960d-7010-bf90-2d42d71eb012.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "On-site dog park with agility equipment on a green lawn"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-8082-71b3-be1e-2a29ba4b7131.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen island with granite countertops and stainless steel appliances."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167634/01a11682-ac5c-720e-8433-97917b33ce15.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a new townhome community with white buildings and dark roofs, surrounded by trees in autumn."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Aerial View"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful leasing team"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Ashley is the best!"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Beautiful townhomes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "These townhomes are absolutely beautiful"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Highly recommended"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "I would definitely recommend this property to others"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2a-8233-7513-93a1-97bf6d00c6d2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Front of a white townhome at Fairforest Creekside with a blue front door and brick accents"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
